meedy.directive('meedyPriceList', ['meedy.availabilityRuleModel',
    function (availabilityRuleModel) {
        var definition = {
            restrict: 'E',
            require: '^form',
            scope: {
                data: '=',
                appointmentLengthOptions: '=',
                readOnly: '='
            },
            templateUrl: 'meedy/application/directive/meedyPriceList/template/meedy-price-list.html',
            link: function ($scope, element, attr) {
                $scope._appointmentLengthList = ($scope.appointmentLengthOptions) ? $scope.appointmentLengthOptions : availabilityRuleModel.generateAppointmentTimeOptions(null, 15, "min");
            }
        };

        return definition;
    }
]);